import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { DetailsPanel } from "@/components/common";
import {
  ArtifactLevelContent,
  ArtifactLevelTraces,
  ArtifactLevelArtifacts,
} from "@/components/artifactType/display";
import { ArtifactLevelButtons } from "@/components/artifactType/save";

/**
 * Displays artifact level information.
 */
const __default__ = {
  name: "ArtifactLevelPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DetailsPanel), {
    panel: "displayArtifactLevel",
    "data-cy": "panel-artifact-type"
  }, {
    actions: _withCtx(() => [
      _createVNode(_unref(ArtifactLevelButtons))
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(ArtifactLevelContent)),
      _createVNode(_unref(ArtifactLevelTraces)),
      _createVNode(_unref(ArtifactLevelArtifacts))
    ]),
    _: 1
  }))
}
}

})